import { TmdxAvatar, Tooltip } from '@ds';
import { ConditionalRender } from '@ui';
import { OpoContactProfileModal } from '@lp/features/modals/OpoContactProfileModal/OpoContactProfileModal';
import { OpoContactTooltip } from '@features/components/CaseOverview/components/OpoContactTooltip/OpoContactTooltip';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { getContactFullName, getFullName } from '@/utils/helpers';
import { AssignedOpoContactType, CaseFacility } from '@/api/apis/case';

interface OpoContactRowProps {
  label: string;
  contact?: AssignedOpoContactType;
  opoDetails?: CaseFacility | null;
}

export const OpoContactRow = ({ label, contact, opoDetails }: OpoContactRowProps) => {
  return (
    <SectionRow label={label}>
      <ConditionalRender show={!!contact && !!opoDetails} placeholder="-">
        <OpoContactProfileModal contact={contact!}>
          <Tooltip className="p-0" content={<OpoContactTooltip opoContact={contact!} opo={opoDetails!} />}>
            <div className="flex gap-2 items-center w-fit truncate">
              <TmdxAvatar
                size="lg"
                radius="lg"
                name={getFullName(contact?.firstName, contact?.lastName)}
                src={contact?.photoPath}
              />
              <div className="w-full truncate">{getContactFullName(contact?.firstName, contact?.lastName)}</div>
            </div>
          </Tooltip>
        </OpoContactProfileModal>
      </ConditionalRender>
    </SectionRow>
  );
};
